import { gql } from '@apollo/client';

export const ADMIN_GET_PERSON = gql`
  query User($personId: Int!) {
    user(personId: $personId) {
      id
      records {
        id
      }
      siblings {
        id
        name
        photoUrl
      }
      parents {
        id
        name
        photoUrl
      }
      children {
        id
        name
        photoUrl
      }
      photoUrl
      buddies {
          id
          name
          photoUrl
      }
      currentCourseAttendances {
        attendance {
            id
            status
        }
        courseId
        course {
            id
            name
            SKU
            teachers {
                id
                name
                photoUrl
            }
        }
      }
      isArchived
      uploadURLSmall
      scriptName
      gender
      haveRegistrationDocument
      registrationDocumentUrl
      hasNewRegistration
      # Both of these are gated server-side: registration comes back null and
      # supportingDocuments empty for anyone who may not see them, so the UI needs no
      # role check of its own. The list and the gate are one answer.
      registration {
        id
        completedAt
        consentDataAggregate
        consentDataReporting
        consentDataPrograms
        consentDataCollection
        consentHealthSafety
        idSightedByCM
        guardianName
        guardianDob
        guardianRelationship
        guardianIsMinorNoAlternative
        guardianConsentsToChildData
        guardianIdSightedConfirmsRelationship
        guardianNoIdButConfirmed
      }
      supportingDocuments {
        id
        kind
        fileName
        contentType
        createdAt
        url
      }
      preferredName
      identifier
      name
      dob
      tags {
        id
        name
      }
      address
      attendancePercentage
      truency
      picturePermission
      # Blank for a viewer the server will not show it to. canAddEmail folds the authority,
      # the scope and the state into one answer -- see backend utils/personEmail.ts.
      email
      canAddEmail
      coursesTeaching {
        id
        name
        SKU
      }
      courses {
        id
        name
        SKU
      }
    }
  }
`;
